'use client';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { localStorageGetItem } from 'src/utils/storage-available';

import { defaultLang } from './config-lang';
import translationEn from './langs/en.json';
import translationHi from './langs/hi.json';

const STORAGE_KEY = 'i18nextLng';

const lng = localStorageGetItem(STORAGE_KEY, defaultLang.value);

i18n.use(initReactI18next).init({
  resources: {
    en: { translations: translationEn },
    hi: { translations: translationHi },
  },
  lng,
  fallbackLng: defaultLang.value,
  ns: ['translations'],
  defaultNS: 'translations',
  interpolation: {
    escapeValue: false,
  },
});

// ✅ Persist language safely
i18n.on('languageChanged', (lang) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, lang);
  }
});

export default i18n;
